//import libraries
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

//import constants
import { AppSettings } from '../constants/app-settings';
import { AppBackRoutes } from '../constants/app-back-routes';

//import models
import { UserLayoutModel } from '../classes/UserLayout.model';

//import language
import { UserLayoutLang } from '../languages/UserLayout.Lang';

//import service
import { GeneralService } from '../services/general.service';
import { UserLayoutListLang } from '../languages/userLayoutList.Lang';

@Injectable()

export class UserLayoutService {

    private datas: BehaviorSubject<UserLayoutModel>;
    
    constructor(
        private http: HttpClient,
        private generalService: GeneralService,
    ){
        this.datas = new BehaviorSubject<UserLayoutModel>(null);
        this.loadData();
    }

    loadData(){
        let userType = parseInt(localStorage.getItem("super_user"));
            userType = userType?userType:0
        let url = AppSettings.API_ENDPOINT+AppBackRoutes.userLayoutData+"/"+userType;

        this.http.get(url)
            .subscribe((datas : UserLayoutModel) => { this.datas.next(datas) });
    }

    get data() : Observable<UserLayoutModel>{
        return this.datas.asObservable();
    }

    userLang(details: any) {

        if (!details) return;
        let instance = new UserLayoutListLang(details.language);
        return instance.lang();

    }    

    userData(resp: UserLayoutModel){
        return (resp) ? resp.userdata : null;
    }

    langData(resp: UserLayoutModel){

        if(!resp)
            return;
        
        let lang = {};

        let gen = resp.language.general;
        lang = Object.assign(lang, { general: this.generalService.service_inject(UserLayoutLang.general, gen) });
        
        return lang;
    }

}